import React from 'react';
import PropTypes from 'prop-types';

import icons from '../../../data/icons';

const AboutMissionVision = ({ t, mission, vision }) => (
    <div className="about-mission-vision">
        <div className="about-mission-vision-container">
            <div className="about-mission-vision-texts">
                <div className="about-mission" dangerouslySetInnerHTML={ { __html: mission } }/>
                <div className="about-vision" dangerouslySetInnerHTML={ { __html: vision } }/>
            </div>
            <div className="about-verified">
                <div className="about-verified-content">
                    <h3>{ t('about.mission_vision.verified.text') }</h3>
                    <span
                      className="about-verified-icon"
                      dangerouslySetInnerHTML={ { __html: icons.about.lock } }
                    />
                </div>
            </div>
        </div>
    </div>
);

AboutMissionVision.propTypes = {
    t: PropTypes.func.isRequired,
    mission: PropTypes.string.isRequired,
    vision: PropTypes.string.isRequired
};

export default AboutMissionVision;



// WEBPACK FOOTER //
// ./src/components/content/about/AboutMissionVision.jsx